import { render, staticRenderFns } from "./Flx__Carousel.vue?vue&type=template&id=358d1aaf&lang=pug&"
import script from "./Flx__Carousel.vue?vue&type=script&lang=js&"
export * from "./Flx__Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports